var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,15.97c-12.146,0-22.027,9.823-22.027,21.897c0,5.677,2.247,12.491,7.071,21.445c3.692,6.853,8.209,13.58,11.507,18.493 l0.41,0.611c0.55,0.812,1.382,1.361,2.345,1.547c0.234,0.045,0.468,0.066,0.701,0.066c0.727,0,1.437-0.216,2.053-0.634 c0.386-0.263,0.715-0.592,0.981-0.986l0.389-0.578c3.304-4.919,7.827-11.655,11.525-18.52c4.824-8.955,7.071-15.77,7.071-21.445 C70.027,25.793,60.146,15.97,48,15.97z M59.435,57.416c-3.605,6.691-8.067,13.335-11.324,18.186L48,75.767l-0.128-0.19 c-3.252-4.845-7.707-11.479-11.307-18.16c-4.498-8.349-6.593-14.561-6.593-19.549c0-9.869,8.087-17.897,18.027-17.897 s18.027,8.028,18.027,17.897C66.027,42.854,63.933,49.066,59.435,57.416z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,27.322c-5.887,0-10.676,4.789-10.676,10.676c0,5.887,4.789,10.676,10.676,10.676s10.676-4.789,10.676-10.676 C58.676,32.111,53.887,27.322,48,27.322z M48,44.674c-3.707,0-6.676-2.969-6.676-6.676c0-3.707,2.969-6.676,6.676-6.676 s6.676,2.969,6.676,6.676C54.676,41.704,51.707,44.674,48,44.674z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.974c779fa99dac4915b362dca73e02b9.svg";
export { ForwardRef as ReactComponent };